import { render, staticRenderFns } from "./Domestic.vue?vue&type=template&id=35db3d85&"
import script from "./Domestic.vue?vue&type=script&lang=js&"
export * from "./Domestic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports